import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartData } from 'common/Components/Report/ChartsManager/types';
import { RootState } from '../../app/store';

import { ReportState } from './types';

const initialState: ReportState = {
    activeFrequency: 0,
    shortcutFrequency: null,
    activeTab: 0,
    charts: null,
    resetCharts: false,
    excelLastFileUrl: null,
    itemSummaryLastFileUrl: null,
};

export const reportSlice = createSlice({
    name: 'report',
    initialState: initialState,
    reducers: {
        setActiveFrequency: (state, action: PayloadAction<number>) => {
            state.activeFrequency = action.payload;
            state.excelLastFileUrl = null;
            state.itemSummaryLastFileUrl = null;
        },
        setShortcutFrequency: (state, action: PayloadAction<number | null>) => {
            state.shortcutFrequency = action.payload;
        },
        setActiveTab: (state, action: PayloadAction<number>) => {
            state.activeTab = action.payload;
        },
        setExcelLastFileUrl: (state, action: PayloadAction<string>) => {
            state.excelLastFileUrl = action.payload;
        },
        setItemSummaryLastFileUrl: (state, action: PayloadAction<string>) => {
            state.itemSummaryLastFileUrl = action.payload;
        },
        setCharts: (state, action: PayloadAction<ChartData>) => {
            state.resetCharts = false;

            state.charts = [
                ...(state.charts ? state.charts : []),
                action.payload,
            ].sort(function (a, b) {
                return a.order - b.order;
            });
        },
        updateChart: (state, action: PayloadAction<number[]>) => {
            let tempCharts = [...(state.charts ? state.charts : [])];

            for (let i = 0; i < action.payload.length; i++) {
                let idx = tempCharts.findIndex(
                    (tc) => tc.order === action.payload[i],
                );

                tempCharts.splice(idx, 1);
            }

            state.charts = tempCharts;
        },
        initiateCharts: (state) => {
            state.charts = [];
        },
        clearCharts: (state) => {
            state.charts = null;
            state.resetCharts = true;
        },
    },
});

export const { setActiveFrequency } = reportSlice.actions;
export const { setShortcutFrequency } = reportSlice.actions;
export const { setActiveTab } = reportSlice.actions;
export const { setExcelLastFileUrl } = reportSlice.actions;
export const { setItemSummaryLastFileUrl } = reportSlice.actions;
export const { setCharts } = reportSlice.actions;
export const { clearCharts } = reportSlice.actions;
export const { initiateCharts } = reportSlice.actions;
export const { updateChart } = reportSlice.actions;

export const selectActiveFrequency = (state: RootState) =>
    state.report.activeFrequency;

export const selectShortcutFrequency = (state: RootState) =>
    state.report.shortcutFrequency;

export const selectActiveTab = (state: RootState) => state.report.activeTab;

export const selectCharts = (state: RootState) => state.report.charts;

export const selectResetCharts = (state: RootState) => state.report.resetCharts;

export const selectExcelLastFileUrl = (state: RootState) =>
    state.report.excelLastFileUrl;

export const selectItemSummaryLastFileUrl = (state: RootState) =>
    state.report.itemSummaryLastFileUrl;

export default reportSlice.reducer;
